<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <h4>Datei-Export</h4>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">

            <div fxLayout.lt-sm="column" fxLayout.gt-xs="row wrap" fxLayoutGap="25px">
                <mat-card appearance="outlined" fxFlex.gt-xs="calc(25%-25px)" fxFlex.lt-sm="calc(100%-25px)" *ngFor="let job of jobTypes">
                    <mat-card-header>
                        <mat-card-title>{{ job.type }}
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        {{ job.displayName }} {{job.name}}
                    </mat-card-content>
                    <mat-card-actions align="end">
                        <button mat-button color="primary" (click)="startJob(job.name)">
                            Starten
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>

            <div fxLayout="row" class="section-header">
                <h2 class="section-headline" fxFlex="50%">Exportierte Dateien</h2>
            </div>
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2" >
            <ng-container matColumnDef="number">
                <th mat-header-cell *matHeaderCellDef>
                    #
                </th>
                <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
                    {{i+1}}
                </td>
            </ng-container>
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="processType">
                    Typ
                </th>
                <td mat-cell *matCellDef="let element" class="mat-column">
                    {{element.processType.displayName}}
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="name">
                    Dateiname
                </th>
                <td mat-cell *matCellDef="let element" class="mat-column">
                    {{element.name}}
                </td>
            </ng-container>

            <ng-container matColumnDef="size">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="size">
                    Größe
                </th>
                <td mat-cell *matCellDef="let element" class="mat-column">
                    {{element.size}}
                </td>
            </ng-container>


            <ng-container matColumnDef="lastModified">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="lastModified">
                    Vom
                </th>
                <td mat-cell *matCellDef="let element" class="mat-column">
                    {{element.lastModified | date : 'dd.MM.YYYY HH:mm'}}
                </td>
            </ng-container>


            <ng-container matColumnDef="menu">
                <th mat-header-cell *matHeaderCellDef>
                    Aktion
                </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                        color="accent">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item  (click)="downloadReport(element.name)">
                            <span>Herunterladen</span>
                        </button>                        
                    </mat-menu>

                </td>
            </ng-container>



            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
        </table>

        <span *ngIf="dataSource?.data.length === 0" class="emptyTableState  mat-elevation-z2">Keine
            passenden
            Einträge
            gefunden...</span>

            <!-- <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Typ</th>
                        <th>Dateiname</th>
                        <th>Größe</th>
                        <th>Datum</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let job of history; let isOdd = odd; let isEven = even;"
                        (click)="downloadExport(job.name)" class="table-selectable-row">
                        <td><span class="badge">{{ job.processType.displayName }}</span></td>
                        <td>
                            {{ job.name }}
                        </td>
                        <td>
                            {{ job.size }}
                        </td>
                        <td>
                            {{ job.lastModified | date:'dd.MM.yyyy hh:mm:ss'}}
                        </td>
                    </tr>
                </tbody>
            </table> -->
        </div>
    </div>
</div>